module.exports = __webpack_public_path__ + "static/media/confabbox.e747c61a.svg";